export enum FilterPageName {
  DEVICES = "devices",
  ACCIDENTS = "accidents",
  TELEM = "telem",
  ALLSENSORS = "allsensors",
  ONESENSOR = "onesensor",
  ROUTES = "routes",
  // Логи: окремий page під кожну вкладку (різний склад ключів у відповіді).
  LOGS_INFO_UPDATES = "logsAllInfoUpdates",
  LOGS_THRESHOLDS_UPDATES = "logsAllThresholdsUpdates",
}
